import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/icons/up-right-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a9822ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container ptb-100" }
const _hoisted_2 = { class: "menu-tag-list list-style mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
        return (_openBlock(), _createElementBlock("li", {
          key: list.id
        }, [
          _createVNode(_component_router_link, { to: "/menu-classic" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(list.title) + " ", 1),
              _createElementVNode("img", {
                src: list.image,
                alt: "Image"
              }, null, 8, _hoisted_3)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    _createVNode(_component_router_link, {
      to: "/menu-classic",
      class: "link-one"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" View Menu "),
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}